<template>
  <div class="bg-grey">
    <div class="page">

<div class="title">{{L('收货地址')}}</div>

<div class="card">
    <div class="user">
      <img :src="user" alt="" style="height: 1.5em;">
      李奇 18115153052
    </div>
    <div class="address">
      <img :src="location" alt="" style="height: 1.5em;">
      南京市秦淮区双乐园小区
    </div>
</div>

<div class="title">{{L('订单信息')}}</div>


<div class="card">
    <div class="item">
    <div class="label">订阅日期</div>
    <div class="value">2022-04</div>
  </div>


  <div class="item">
    <div class="label">订阅期数</div>
    <div class="value">{{ 24 }}</div>
  </div>

  <div class="item">
    <div class="label">用户类别</div>
    <div class="value">{{ '企业' }}</div>
  </div>

  <div class="item">
    <div class="label">订户编号</div>
    <div class="value">{{ '12333' }}</div>
  </div>




</div>

<div class="title">{{L('发票信息')}}</div>


<div class="card">

  <div class="item">
    <div class="label">E-mail</div>
    <div class="value">191@qq.com</div>
  </div>


  <div class="item">
    <div class="label">发票抬头</div>
    <div class="value">0x123</div>
  </div>

  <div class="item">
    <div class="label">公司税号</div>
    <div class="value">abc</div>
  </div>






</div>

<div style="
margin-top: 24px; text-align: center;">


      <el-button type="danger">
    {{ L("立即支付") }}
</el-button>


</div>

</div>
  </div>
</template>


<script>

import user from './user.png'
import location from './location.png'

export default {

  data() {
    return {

      user,
      location,

    };
  },

  mounted() {
  //   const url = "/Api/Survey/getDetail?uuid=" + uuid;

  //   fetch(url, {
  //     method: "post",
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       console.log("res", res);
  //       if (res.info) {
  //         this.info = {
  //           ...res.info,
  //           questions: res.info.questions.map((item) => {
  //             return {
  //               ...item,
  //               other: "",
  //             };
  //           }),
  //         };
  //       }
  //     });
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);


          const formData = new FormData();
          formData.append("uuid", this.uuid);

          if (this.owner) {
            formData.append("owner", this.owner);
          } else {
            formData.append("owner", values[0]);
          }
          formData.append(
            "answer",
            JSON.stringify({
              ...this.info,
              questions: this.info.questions.map((item, index) => {
                return {
                  ...item,
                  answer: Array.isArray(values[index])
                    ? values[index].join("|") +
                      (item.other ? "：" + item.other : "")
                    : typeof values[index] === "string"
                    ? values[index] + (item.other ? "：" + item.other : "")
                    : values[index].format("YYYY-MM-DD"),
                };
              }),
            })
          );

          fetch("/Api/Survey/updateResult", {
            method: "post",
            body: formData,
          })
            .then((res) => res.json())
            .then((res) => {
              alert(this.L(res.info));
              if (res.status === 1) {
                this.form.resetFields();
              }
            });
        } else {
          alert(this.L("还有表单待填写"));
        }
      });
    },
  },
};
</script>

<style scoped>
.page {
  max-width: 1000px;
margin: 0 auto;
padding: 24px;
}
.card {
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 8px 4px rgba(0, 0, 0, .05);
}

.user {
  margin-bottom: 8px;
}


.title {
  font-weight: bold;
  font-size: 18px;
  margin: 24px 16px;
  position: relative;
  color: #000;
  line-height: 1;

}
.title::before {
  content: '';
  position: absolute;
  top: 0%;
  left: -10px;
  background-color: red;
  width: 3px;
  height: 1em;
}

.title:first-child {
  margin-top: 8px;
}



.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 12px ;
  margin-bottom: 12px;
}
.item:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom-width: 0;
}


</style>



// WEBPACK FOOTER //
// src/views/pay/index.vue